import { render, staticRenderFns } from "./timeslotAction.vue?vue&type=template&id=22878398"
import script from "./timeslotAction.vue?vue&type=script&lang=js"
export * from "./timeslotAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports